import ReactMarkdown from 'react-markdown'
import remarkMath from 'remark-math'
import remarkBreaks from 'remark-breaks'
import remarkGfm from 'remark-gfm'

import rehypeKatex from 'rehype-katex'
import 'katex/dist/katex.min.css'

import dynamic from 'next/dynamic'

// fix 服务端无法处理code 需要延迟引入
const CodeBlock = dynamic(() => import('./MarkdownCodeBlock'), {
  ssr: false,
})
export default function Markdown({
  children,
  className,
}: {
  children: string
  className?: string
}) {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkMath, remarkBreaks, remarkGfm]}
      rehypePlugins={[rehypeKatex]}
      className={`break-words ${className || ''}`}
      components={{
        // @ts-ignore
        code: (props: any) => CodeBlock.render?.({ ...props }),
        a: ({ node, ...props }) => (
          <a
            {...props}
            target="_blank"
            rel="noreferrer"
            onClick={e => {
              e.stopPropagation()
            }}
          />
        ),
      }}
    >
      {children}
    </ReactMarkdown>
  )
}
